<template>
  <div class="enterprise-management">
    <div class="header">
      <h2>企业管理</h2>
      <div class="header-ops">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.keyword" placeholder="搜索企业名称/法人/信用代码" clearable
              @clear="handleSearch" @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加企业</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="importDialogVisible = true">导入企业(CSV)</el-button>
      </div>
    </div>

    <!-- 企业列表表格 -->
    <el-table :data="enterprises" v-loading="loading" border row-key="id" style="width: 100%">
      <el-table-column type="index" label="序号" width="80" align="center" :index="indexMethod"></el-table-column>
      <el-table-column label="Logo" width="100">
        <template slot-scope="scope">
          <img v-if="scope.row.logo" :src="$http.getFullImageUrl(scope.row.logo)"
            style="width: 60px; height: 40px; object-fit: cover; border-radius: 4px;">
          <span v-else style="color: #999; font-size: 12px;">无Logo</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="企业名称" min-width="200"></el-table-column>
      <el-table-column prop="creditRating" label="信用评级" width="120"></el-table-column>
      <el-table-column prop="legalRepresentative" label="法人代表" width="120"></el-table-column>
      <el-table-column prop="registeredCapital" label="注册资本" width="120">
        <template slot-scope="scope">
          {{ scope.row.registeredCapital ? scope.row.registeredCapital + '万元' : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'info'">
            {{ scope.row.status === 'ACTIVE' ? '正常' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页条 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 添加/编辑企业对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="enterpriseForm" :rules="rules" ref="enterpriseForm" label-width="120px">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="enterpriseForm.name" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="统一信用代码" prop="creditCode">
          <el-input v-model="enterpriseForm.creditCode" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="信用评级" prop="creditRating">
          <el-select v-model="enterpriseForm.creditRating" placeholder="请选择信用评级">
            <el-option label="AAA" value="AAA"></el-option>
            <el-option label="AA" value="AA"></el-option>
            <el-option label="A" value="A"></el-option>
            <el-option label="BBB" value="BBB"></el-option>
            <el-option label="BB" value="BB"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人代表" prop="legalRepresentative">
          <el-input v-model="enterpriseForm.legalRepresentative" placeholder="请输入法人代表"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证" prop="legalPersonIdCard">
          <el-input v-model="enterpriseForm.legalPersonIdCard" placeholder="请输入法人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="enterpriseForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="注册资本" prop="registeredCapital">
          <el-input v-model.number="enterpriseForm.registeredCapital" placeholder="请输入注册资本（万元）">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="注册日期" prop="registrationDate">
          <el-date-picker v-model="enterpriseForm.registrationDate" type="date" placeholder="选择注册日期"
            value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="业务范围" prop="businessScope">
          <el-input type="textarea" v-model="enterpriseForm.businessScope" placeholder="请输入业务范围" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="提供服务" prop="services">
          <el-input type="textarea" v-model="enterpriseForm.services" placeholder="请输入提供的服务" :rows="3"></el-input>
        </el-form-item>

        <!-- 图片上传区域 -->
        <el-form-item label="企业Logo" prop="logo">
          <div class="upload-with-download">
            <el-upload class="avatar-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
              :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'logo')"
              :before-upload="beforeImageUpload">
              <img v-if="enterpriseForm.logo" :src="$http.getFullImageUrl(enterpriseForm.logo)" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button v-if="enterpriseForm.logo" type="text" icon="el-icon-download" @click="downloadFile(enterpriseForm.logo, '企业Logo')">下载</el-button>
          </div>
        </el-form-item>

        <el-form-item label="营业执照" prop="licenseUrl">
          <div class="upload-with-download">
            <el-upload class="avatar-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
              :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'licenseUrl')"
              :before-upload="beforeImageUpload">
              <img v-if="enterpriseForm.licenseUrl" :src="$http.getFullImageUrl(enterpriseForm.licenseUrl)"
                class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button v-if="enterpriseForm.licenseUrl" type="text" icon="el-icon-download" @click="downloadFile(enterpriseForm.licenseUrl, '营业执照')">下载</el-button>
          </div>
        </el-form-item>

        <el-form-item label="身份证正面" prop="idCardFrontUrl">
          <div class="upload-with-download">
            <el-upload class="avatar-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
              :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'idCardFrontUrl')"
              :before-upload="beforeImageUpload">
              <img v-if="enterpriseForm.idCardFrontUrl" :src="$http.getFullImageUrl(enterpriseForm.idCardFrontUrl)"
                class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button v-if="enterpriseForm.idCardFrontUrl" type="text" icon="el-icon-download" @click="downloadFile(enterpriseForm.idCardFrontUrl, '身份证正面')">下载</el-button>
          </div>
        </el-form-item>

        <el-form-item label="身份证反面" prop="idCardBackUrl">
          <div class="upload-with-download">
            <el-upload class="avatar-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
              :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'idCardBackUrl')"
              :before-upload="beforeImageUpload">
              <img v-if="enterpriseForm.idCardBackUrl" :src="$http.getFullImageUrl(enterpriseForm.idCardBackUrl)"
                class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button v-if="enterpriseForm.idCardBackUrl" type="text" icon="el-icon-download" @click="downloadFile(enterpriseForm.idCardBackUrl, '身份证反面')">下载</el-button>
          </div>
        </el-form-item>

        <el-form-item label="收款二维码" prop="paymentQrCode">
          <div class="upload-with-download">
            <el-upload class="avatar-uploader" :action="uploadConfig.action" :headers="uploadConfig.headers"
              :show-file-list="false" :on-success="(res) => handleUploadSuccess(res, 'paymentQrCode')"
              :before-upload="beforeImageUpload">
              <img v-if="enterpriseForm.paymentQrCode" :src="$http.getFullImageUrl(enterpriseForm.paymentQrCode)"
                class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button v-if="enterpriseForm.paymentQrCode" type="text" icon="el-icon-download" @click="downloadFile(enterpriseForm.paymentQrCode, '收款二维码')">下载</el-button>
          </div>
          <div class="upload-tip">请上传您的微信/支付宝收款码，方便客户直接扫码支付</div>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="enterpriseForm.status">
            <el-radio label="ACTIVE">正常</el-radio>
            <el-radio label="INACTIVE">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入企业弹窗 -->
    <el-dialog title="自助导入企业(CSV)" :visible.sync="importDialogVisible" width="500px">
      <div style="margin-bottom: 15px; color: #606266; line-height: 1.8;">
        <p>1. 支持标准的 CSV 格式（UTF-8编码），逗号分隔。</p>
        <p>2. CSV 列顺序为：<b>企业名称,信用评级,经营范围,主营服务,法人代表,注册资本(万元)</b></p>
        <p>3. <el-link type="primary" @click="downloadTemplate">下载企业导入CSV模板</el-link></p>
      </div>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="handleUploadImport"
        :limit="1"
        :show-file-list="true"
        accept=".csv">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将 CSV 文件拖到此处，或 <em>点击上传导入</em></div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
// 使用全局的 $http 而不是单独的 api 配置

export default {
  name: 'EnterpriseManagement',
  data() {
    return {
      enterprises: [],
      loading: false,
      dialogVisible: false,
      importDialogVisible: false,
      dialogTitle: '添加企业',
      isEdit: false,
      submitting: false,
      searchForm: {
        keyword: ''
      },
      enterpriseForm: {
        id: null,
        name: '',
        creditCode: '',
        creditRating: '',
        legalRepresentative: '',
        legalPersonIdCard: '',
        phone: '',
        registeredCapital: null,
        registrationDate: '',
        businessScope: '',
        services: '',
        logo: '',
        licenseUrl: '',
        idCardFrontUrl: '',
        idCardBackUrl: '',
        paymentQrCode: '',
        status: 'ACTIVE'
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },

      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        creditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        creditRating: [
          { required: true, message: '请选择信用评级', trigger: 'change' }
        ],
        legalRepresentative: [
          { required: true, message: '请输入法人代表', trigger: 'blur' }
        ],
        registeredCapital: [
          { required: true, message: '请输入注册资本', trigger: 'blur' },
          { type: 'number', message: '注册资本必须为数字', trigger: 'blur' }
        ],
        registrationDate: [
          { required: true, message: '请选择注册日期', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadConfig() {
      return this.$http.getUploadConfig()
    }
  },
  mounted() {
    this.loadEnterprises()
  },
  methods: {
    async loadEnterprises() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.page,
          size: this.pagination.size,
          keyword: this.searchForm.keyword
        }
        const response = await this.$http.get('/enterprise-management/enterprises', { params })
        if (response.success) {
          this.enterprises = response.data || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error('加载企业列表失败: ' + (response.message || ''))
        }
      } catch (error) {
        console.error('加载企业列表失败:', error)
        this.$message.error('加载企业列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadEnterprises()
    },
    async handleUploadImport(param) {
      try {
        const formData = new FormData()
        formData.append('file', param.file)
        const res = await this.$http.post('/enterprise-management/enterprises/batch-import', formData)
        if (res.success) {
          this.$message.success(`成功导入 ${res.data.success} 家企业！`)
          this.importDialogVisible = false
          this.loadEnterprises()
        } else {
          this.$message.error('导入失败: ' + (res.message || '格式或字段不规范'))
        }
      } catch (err) {
        this.$message.error('导入出错，请检查CSV格式')
      }
    },
    downloadTemplate() {
      const csvContent = "企业名称,信用评级,经营范围,主营服务,法人代表,注册资本(万元)\n杭锦旗生态农业开发有限公司,AAA,特色牛肉与农副产品加工,农产品电商销售,张农,500\n"
      const blob = new Blob(["\uFEFF" + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = "企业信息导入模板.csv"
      link.click()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.page = 1
      this.loadEnterprises()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadEnterprises()
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '添加企业'
      this.dialogVisible = true
      this.resetForm()
    },
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑企业'
      this.enterpriseForm = {
        id: row.id,
        name: row.name,
        creditCode: row.creditCode,
        creditRating: row.creditRating,
        legalRepresentative: row.legalRepresentative,
        legalPersonIdCard: row.legalPersonIdCard,
        phone: row.phone,
        registeredCapital: row.registeredCapital,
        registrationDate: row.registrationDate,
        businessScope: row.businessScope,
        services: row.services,
        logo: row.logo || '',
        licenseUrl: row.licenseUrl || '',
        idCardFrontUrl: row.idCardFrontUrl || '',
        idCardBackUrl: row.idCardBackUrl || '',
        paymentQrCode: row.paymentQrCode || '',
        status: row.status || 'ACTIVE'
      }
      this.dialogVisible = true
    },

    handleUploadSuccess(response, field) {
      if (response.success && response.data) {
        this.enterpriseForm[field] = response.data.fileUrl
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败: ' + (response.message || '未知错误'))
      }
    },

    beforeImageUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!isImage) {
        this.$message.error('只能上传 JPG 或 PNG 格式!')
      }
      if (!isLt20M) {
        this.$message.error('图片大小不能超过 20MB!')
      }
      return isImage && isLt20M
    },
    handleDelete(row) {
      this.$confirm(`确定要删除企业"${row.name}"吗？删除后将无法恢复，且会删除该企业的所有关联数据。`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.delete(`/enterprise-management/enterprises/${row.id}`)
          if (response.success) {
            this.$message.success('删除成功')
            this.loadEnterprises()
          } else {
            this.$message.error('删除失败: ' + response.message)
          }
        } catch (error) {
          console.error('删除企业失败:', error)
          this.$message.error('删除企业失败')
        }
      }).catch(() => {
        // 用户取消删除
      })
    },
    indexMethod(index) {
      return (this.pagination.page - 1) * this.pagination.size + index + 1
    },
    handleSubmit() {
      if (this.submitting) {
        return
      }
      this.$refs.enterpriseForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        try {
          this.submitting = true
          let response
          if (this.isEdit) {
            // 编辑企业
            response = await this.$http.put(`/enterprise-management/enterprises/${this.enterpriseForm.id}`, this.enterpriseForm)
          } else {
            // 添加企业
            response = await this.$http.post('/enterprise-management/enterprises', this.enterpriseForm)
          }

          if (response.success) {
            this.$message.success(this.isEdit ? '企业更新成功' : '企业添加成功')
            this.dialogVisible = false
            if (!this.isEdit) {
              this.pagination.page = 1
            }
            this.loadEnterprises()
          } else {
            this.$message.error('保存失败: ' + response.message)
          }
        } catch (error) {
          console.error('保存企业失败:', error)
          this.$message.error('保存企业失败: ' + (error.message || ''))
        } finally {
          this.submitting = false
        }
      })
    },
    resetForm() {
      this.enterpriseForm = {
        id: null,
        name: '',
        creditCode: '',
        creditRating: '',
        legalRepresentative: '',
        legalPersonIdCard: '',
        phone: '',
        registeredCapital: null,
        registrationDate: '',
        businessScope: '',
        services: '',
        logo: '',
        licenseUrl: '',
        idCardFrontUrl: '',
        idCardBackUrl: '',
        paymentQrCode: '',
        status: 'ACTIVE'
      }
    },
    handleDialogClose() {
      this.$refs.enterpriseForm.resetFields()
      this.resetForm()
    },
    downloadFile(url, type) {
      if (!url) return
      const filename = `${this.enterpriseForm.name || '企业'}_${type}.${url.split('.').pop()}`
      this.$http.downloadImage(url, filename)
    }
  }
}
</script>

<style scoped lang="scss">
.upload-with-download {
  display: flex;
  align-items: flex-end;
  gap: 15px;
}
.enterprise-management {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 24px;
      color: #333;
    }

    .header-ops {
      display: flex;
      align-items: center;
      gap: 15px;

      .search-form {
        margin-bottom: 0;

        .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  transition: border-color 0.3s;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  display: block;
}

.avatar {
  display: block;
}

@media screen and (max-width: 768px) {
  .enterprise-management {
    .header {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;

      h2 {
        font-size: 20px;
      }

      button {
        width: 100%;
      }
    }
  }

  // 优化表格在移动端的显示
  ::v-deep .el-table {
    font-size: 12px;

    .el-table__header th,
    .el-table__body td {
      padding: 8px 5px;
    }

    // 隐藏一些不太重要的列
    .el-table__body-wrapper {
      overflow-x: auto;
    }
  }

  // 优化对话框在移动端的显示
  ::v-deep .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>